var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnmute(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.991211,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FF0000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3266_10410",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 25,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.9912,
    y: 12,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3266_10410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7911 34.5998L29.7661 31.5748C29.3494 31.8415 28.9078 32.0706 28.4411 32.2623C27.9744 32.454 27.4911 32.6081 26.9911 32.7248V30.6748C27.2244 30.5915 27.4536 30.5081 27.6786 30.4248C27.9036 30.3415 28.1161 30.2415 28.3161 30.1248L24.9911 26.7998V31.9998L19.9911 26.9998H15.9911V20.9998H19.1911L14.3911 16.1998L15.7911 14.7998L34.1911 33.1998L32.7911 34.5998ZM32.5911 28.7998L31.1411 27.3498C31.4244 26.8331 31.6369 26.2915 31.7786 25.7248C31.9203 25.1581 31.9911 24.5748 31.9911 23.9748C31.9911 22.4081 31.5328 21.0081 30.6161 19.7748C29.6994 18.5415 28.4911 17.7081 26.9911 17.2748V15.2248C29.0578 15.6915 30.7411 16.7373 32.0411 18.3623C33.3411 19.9873 33.9911 21.8581 33.9911 23.9748C33.9911 24.8581 33.8703 25.7081 33.6286 26.5248C33.3869 27.3415 33.0411 28.0998 32.5911 28.7998ZM29.2411 25.4498L26.9911 23.1998V19.9498C27.7744 20.3165 28.3869 20.8665 28.8286 21.5998C29.2703 22.3331 29.4911 23.1331 29.4911 23.9998C29.4911 24.2498 29.4703 24.4956 29.4286 24.7373C29.3869 24.979 29.3244 25.2165 29.2411 25.4498ZM24.9911 21.1998L22.3911 18.5998L24.9911 15.9998V21.1998ZM22.9911 27.1498V24.7998L21.1911 22.9998H17.9911V24.9998H20.8411L22.9911 27.1498Z",
    fill: "#1C1B1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmute);
export default __webpack_public_path__ + "static/media/unmute.921ed4c14a83557ec3543470b4056948.svg";
export { ForwardRef as ReactComponent };